module.exports = __webpack_public_path__ + "static/media/favicon.a27467df.ico";